import React, {useCallback, useState} from 'react';
import Backdrop from "@mui/material/Backdrop";
import {Box, Fade, Modal, Typography} from "@mui/material";
import {amo, pipedrive, global, input} from "../translate";
import Api from "../Api";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {REACT_APP_API_URL} from '../config';
const {REACT_APP_SERVER,} = process.env;

import {style} from "../helpers/style";

const REDIRECT_URI = REACT_APP_SERVER === 'ATS'?'https://account.ats.am':REACT_APP_API_URL;

/** Normalize to https://host with no trailing slash (and no path). */
function normalizePipedriveDomain(raw) {
    let value = String(raw || '').trim()
    if (!value) return ''
    value = value.replace(/\/+$/, '')
    if (!/^https?:\/\//i.test(value)) {
        value = `https://${value}`
    }
    try {
        const url = new URL(value)
        return `https://${url.host}`
    } catch {
        return value.replace(/^http:\/\//i, 'https://').replace(/\/+$/, '')
    }
}

function PipeDriveEnter({open, setOpen,setIsInstalled}) {
    const [domain, setDomain] = useState('')
    const navigate = useNavigate()
    const handleSubmit = useCallback(async (ev) => {
        ev.preventDefault()
        const normalizedDomain = normalizePipedriveDomain(domain)
        if (!normalizedDomain) return
        setDomain(normalizedDomain)
        try {
            const {data} = await Api.pipedrive_domain(normalizedDomain)
            setIsInstalled((prev) => ({...prev,pipedrive:data.status}))
            navigate('/crm_integration')
            setOpen('')

        } catch (e) {
            toast.error(e.response.data.message)
        }
    }, [domain,REDIRECT_URI,REACT_APP_SERVER])
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => {
                setOpen(false)
            }}
            closeAfterTransition
            slots={{backdrop: Backdrop}}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style}>

                    <form onSubmit={handleSubmit} className="d-flex flex-column justify-content-between">
                        <div className="d-flex justify-content-between">
                            <h3>{pipedrive.header[+localStorage.getItem('atsLang')  || 1]}</h3>
                            <span style={{cursor: 'pointer'}} onClick={() => {
                                setOpen('')
                                navigate('/crm_integration')
                            }}>
                            x
                            </span>
                        </div>
                        <p className="crm_title"><span
                            className="number">1. </span><span>{REACT_APP_SERVER === 'ATS'?pipedrive.titleA[+localStorage.getItem('atsLang')  || 1]:pipedrive.title[+localStorage.getItem('atsLang')  || 1]}</span>
                        </p>
                        <p className="crm_paragraph"><span>{pipedrive.paragraph_p1[+localStorage.getItem('atsLang')  || 1]}
                            <a href={REACT_APP_SERVER === 'ATS'?pipedrive.link.linkA :REACT_APP_SERVER === 'V-office'?pipedrive.link.linkV : pipedrive.link.link} target='_blank'>{REACT_APP_SERVER === 'ATS'?pipedrive.link.textA[+localStorage.getItem('atsLang')  || 1]:pipedrive.link.text[+localStorage.getItem('atsLang')  || 1]}</a>{pipedrive.paragraph_p2[+localStorage.getItem('atsLang')  || 1]}</span>
                        </p>
                        <p className="crm_title"><span
                            className="number">2. </span><span>{pipedrive.title2[+localStorage.getItem('atsLang')  || 1]}</span>
                        </p>
                        <p className="crm_paragraph"><span>{pipedrive.paragraph2[+localStorage.getItem('atsLang')  || 1]}</span>
                        </p>
                    </form>
                    <div id="transition-modal-description sip_content" className="test_mode">
                        <label className="count" style={{width: '93%',marginBottom:30}}>
                            <input placeholder="https://example-sandbox.pipedrive.com" value={domain} onChange={(ev) => setDomain(ev.target.value)}/>
                        </label>
                        <div className="d-flex justify-content-center">
                            <button style={{padding: '6px 17px'}} className="addBtn" onClick={handleSubmit}>
                                {global.edit[+localStorage.getItem('atsLang')  || 1]}
                            </button>
                        </div>
                    </div>
                </Box>
            </Fade>
        </Modal>
    );
}

export default PipeDriveEnter;
